module.exports = __webpack_public_path__ + "img/20191210162321782.a4644ec1.jpg";